import React, { Component } from "react";
import api from "../../services/api";
import { Link } from "react-router-dom";
import { Map, Marker, Popup, TileLayer } from "react-leaflet";
import { Navbar, NavItem, DropdownMenu, Logo } from "../../components/header";
import { BsChevronDown } from "react-icons/bs";
import { BsGeoAlt } from "react-icons/bs";
import { BsTagFill } from "react-icons/bs";
import "./styles.css";
import Index from "../../components/productsContainer";

export default class classeMapa extends Component {
  state = {
    empresas: [],
    localizacaoViewport: [-22.872409, -47.210676],
  };

  componentDidMount() {
    this.loadEmpresas();
  }

  loadEmpresas = async () => {
    const empresas = await api.get("/empresas/");
    this.setState({ empresas: empresas.data });
  };

  // [51.505, -0.09]
  render() {
    document.body.style.overflow = "hidden";
    const { empresas } = this.state;
    return (
      <div>
        <div>
          <Logo />
          <Navbar>
            <NavItem icon={<BsTagFill />} link="/product"></NavItem>
            <NavItem icon={<BsGeoAlt />} link="/map"></NavItem>
            <NavItem icon={<BsChevronDown />}>
              <DropdownMenu />
            </NavItem>
          </Navbar>
        </div>
        <Map
          className="mapa"
          center={[-22.872409, -47.210676]}
          zoom={16}
          onViewportChanged={(viewport) =>
            this.setState({ localizacaoViewport: viewport.center })
          }
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          />

          {empresas.map((values) => (
            <Marker position={values.endereco}>
              <Popup key={values._id}>
                {values.nome}
                <br />
                {values.descricao}
                <br />
                <br />

                <Link to={"/profilealh?id=" + values._id}>Acessar Perfil</Link>
              </Popup>
            </Marker>
          ))}
        </Map>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <div className="userContainer">
            <div>
              <Index viewport={this.state.localizacaoViewport} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
